import { StepErrorType } from '../../../types/types';

export enum CodeStatus {
  Empty = 'empty',
  Error = 'error',
  Waiting = 'waiting',
  Accepted = 'accepted',
  NotNeeded = 'notNeeded',
}

export enum PaymentOption {
  PayPal = 'paypal',
  PayPalPlus = 'paypal-plus',
  PayPalCheckout = 'paypal-checkout',
  Prepayment = 'prepayment',
  Reservation = 'reservation',
  StripeIdeal = 'stripe-ideal',
  StripeCC = 'stripe-cc',
  StripeSepa = 'stripe-sepa',
  StripeSofort = 'stripe-sofort',
  StripeBanContact = 'stripe-bancontact',
  GiftCard = 'giftcard',
  StripeP24 = 'stripe-p24',
  StripeBlik = 'stripe-blik',
  StripeTwint = 'stripe-twint',
  StripeExpressCheckout = 'stripe-express-checkout',
}

export interface PaymentError {
  type: StepErrorType;
  message?: string;
}

export interface PaymentCustomer {
  fullName: string;
  email: string;
  country: string;
}

export interface ValidateAndPayProps {
  isOrder?: boolean;
  onValidateSuccess?: () => void;
  onValidateError?: () => void;
  onPaymentSuccess?: () => void;
  onPaymentSuccessNoRedirect?: () => void;
  onPaymentError?: () => void;
}
